module.exports = __webpack_public_path__ + "static/media/irishlife.5be8af0a.png";